import React from 'react'
import styled from 'styled-components'
import cookie from 'react-cookies'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

// import 'react-slidedown/lib/slidedown.css'
import ReactTooltip from 'react-tooltip'
import { rem } from 'polished'
import { useTranslation } from 'react-i18next'
import Loader from '../Loader/Loader.tsx'
import { usePromiseTracker } from 'react-promise-tracker'

import { GenericContainer } from '../shared/DefaultStyledComponents'
import { TopColorBar } from '../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen'
import DemoModeAnnouncement from '../DemoModeAnnouncement/DemoModeAnnouncement.jsx'
import NewsItem from './subComponents/Newsitem'
import DropdownMenu from './subComponents/DropdownMenu'
import settingsIcon from '../../assets/mainScreen/settingsIcon.svg'
// import NavigationBar, {
//   SvgElement,
//   NavElementName,
// } from './subComponents/NavigationBar'
import trenningImage from '../../assets/mainScreen/trenningSection/placeholderImage.png'
import deleteIcon from '../../assets/entryScreen/deleteIcon.png'
import Player from './subComponents/Player/Player'
import { useAddToHomescreenPrompt } from '../../utils/useAddToHomeScreenPrompt.tsx'
import newVideoIcon from '../../assets/mainScreen/newVideoIcon.png'
import { isMobile } from 'react-device-detect'
import { fontSizeResponsive, mediaQ } from '../theme/mixins'
import ChatModal from './subComponents/ChatModal.jsx'
import chatButtonIcon from '../../assets/mainScreen/chatBoxIcon.png'
import platform from 'platform'
import NavigationBar from '../shared/NavigationBar/NavigationBarContainer.js'

export const WelcomeHeader = styled.div`
  font-family: 'Asap Condensed';
  ${(props) =>
    props.fontSmaller ? fontSizeResponsive(62) : fontSizeResponsive(85)};
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  letter-spacing: normal;
  text-align: ${(props) => (props.textCenter ? 'center' : 'left')};
  color: #fe0d9f;
  margin-top: ${isMobile ? rem(20) : rem(20)};
  padding-left: 3.8%;

  ${mediaQ('mobileS', 'font-size:30px; padding-left: 2%;')}

  ${(props) =>
    props.isVisible === false ? mediaQ('mobileAll', 'display: none') : null}
`
export const WelcomeSubHeader = styled.div`
  font-family: 'Open Sans', sans-serif;
  ${fontSizeResponsive(24)}
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
  margin-top: 10px;
  padding-left: 3.8%;

  ${(props) =>
    props.isVisible === false ? mediaQ('mobileAll', 'display: none') : null}
`
const MainContent = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: 3%;

  ${mediaQ('mobileAll', 'flex-direction: column; margin-top: 5%;')}

  ${mediaQ('oldIpads', 'flex-direction: column;')}
  ${mediaQ('ipad9', 'flex-direction: column;')}
  ${mediaQ('ipad10', 'flex-direction: column;')}
  ${mediaQ('ipad12', 'flex-direction: column;')}
`

const NewsSection = styled.div`
  width: 50%;
  padding: 0 3.8%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  ${mediaQ('mobileAll', 'width: 100%; overflow: scroll;')}

  ${mediaQ('oldIpads', 'width: 100%; overflow: scroll;')}
  ${mediaQ('ipad9', 'width: 100%; overflow: scroll;')}
  ${mediaQ('ipad10', 'width: 100%; overflow: scroll;')}
  ${mediaQ('ipad12', 'width: 100%; overflow: scroll;')}
`
const NewsContainer = styled.div`
  padding-top: 5%;
  ${mediaQ(
    'mobileAll',
    'justify-content: center; flex-direction: row; overflow-y: auto;width: max-content; padding-top:7%;'
  )}

  ${mediaQ(
    'oldIpads',
    'justify-content: center; flex-direction: row; overflow-y: auto;  width: max-content; padding-top:7%;'
  )}
  ${mediaQ(
    'ipad9',
    'justify-content: center; flex-direction: row; overflow-y: auto;  width: max-content; padding-top:7%;'
  )}
  ${mediaQ(
    'ipad10',
    'justify-content: center; flex-direction: row; overflow-y: auto; width: max-content; padding-top:7%;'
  )}
  ${mediaQ(
    'ipad12',
    'justify-content: center; flex-direction: row; overflow-y: auto; width: max-content; padding-top:7%;'
  )}
`
const FoldersSection = styled.div`
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  padding: 0 3.8%;
  justify-content: space-between;

  box-sizing: border-box;
  border-right: rgba(254, 13, 159, 0.1) 2px solid;
  max-height: 65vh;

  ${mediaQ(
    'mobileAll',
    'width: 100%; flex-direction: column; flex-wrap: nowrap; max-height: unset; margin-bottom: 10vh;'
  )}

  ${mediaQ('oldIpads', 'width: 100%; margin-top:40px; ')}
  ${mediaQ('ipad9', 'width: 100%; margin-top:40px;')}
  ${mediaQ('ipad10', 'width: 100%; margin-top:40px;')}
  ${mediaQ('ipad12', 'width: 100%; margin-top:40px;')}
`
const Folder = styled.div`
  position: relative;
  width: 17.9vw;
  height: 10.5vh;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin: 5px 0.5vw;
  cursor: ${(props) => (!props.isEnabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (!props.isEnabled ? '0.3' : '1')};
  background: url(${(props) => (props.picture ? props.picture : null)});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);

  border-radius: 3px;

  outline: ${(props) =>
    props.name === props.pickedFolder ? '3px solid #fff' : 'unset'};
  outline-offset: ${(props) =>
    props.name === props.pickedFolder ? '-5px' : 'unset'};

  transform: ${(props) =>
    props.name === props.pickedFolder ? 'scale(1.06)' : 'unset'};

  &:hover {
    ${(props) => (!props.isEnabled ? 'unset' : 'transform: scale(1.06)')};
  }

  ${mediaQ('mobileAll', 'width: 100%; height: 100px')}

  ${mediaQ('oldIpads', '40vw; ')}
  ${mediaQ('ipad9', 'width: 40vw; ')}
  ${mediaQ('ipad10', 'width: 40vw; ')}
  ${mediaQ('ipad12', 'width: 40vw;')}
`
const FolderName = styled.div`
  font-family: 'Asap Condensed';
  /* font-size: 43px; */

  ${fontSizeResponsive(31)}
  font-weight: bold;
  font-stretch: condensed;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  text-transform: uppercase;

  ${mediaQ('mobileAll', 'display: flex; flex-direction: column;')}

  small {
    font-family: 'Open Sans', sans-serif;
    ${fontSizeResponsive(14)}
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff;
    margin-left: 15px;

    ${mediaQ('mobileAll', 'margin-left:0;')}
  }
`
const NewsSectionHeader = styled.div`
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(33)}
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  letter-spacing: normal;
  text-transform: uppercase;
  /* text-align: left; */
  color: #fe0d9f;
  ${mediaQ('mobileAll', 'position: absolute')}
`
const GlobalSettingsButtonContainer = styled.div`
  width: 7%;
  height: 2%;
  position: absolute;
  top: 3.5vh;
  right: 1vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: flex-end; */
  div {
    display: flex;
    justify-content: center;
  }
  svg {
    width: 25%;
    height: 100%;

    ${mediaQ('mobileAll', 'width: 80%;margin-top:10px;')}
  }
`
export const MainScreenMainHeader = styled.div`
  position: absolute;
  width: 30%;
  left: 35%;
  top: 20%;
  text-align: center;
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(62)};
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  color: #fe0d9f;

  ${mediaQ(
    'mobileAll',
    'position: relative; width: 100%; left: unset; top:30%'
  )}

  ${mediaQ('oldIpads', ' top: 24%; ')}
  ${mediaQ('ipad9', ' top: 24%; ')}
  ${mediaQ('ipad10', ' top: 24%; ')}
  ${mediaQ('ipad12', ' top: 24%; ')}
`
// const GlobalSettingsButtonText = styled(NavElementName)``

const FolderVideoContainer = styled.div`
  margin-top: 5%;
`
const FolderVideo = styled.div`
  display: flex;
  cursor: pointer;
`

const VideoImage = styled.div`
  width: 150px;
  height: 150px;
  background-image: ${(props) => `url(${props.source})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

const VideoInfo = styled.div`
  display: flex;
  flex-direction: column;
`
const VideoInfoRow = styled.span`
  font-family: 'Asap Condensed';

  font-weight: 500;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  padding: 8px 25px 8px 8px;

  &:nth-of-type(1) {
    font-size: 21px;
    color: black;
    font-weight: 600;
  }

  &:nth-of-type(2) {
    background: rgb(250, 174, 1);
    background: linear-gradient(
      90deg,
      rgba(250, 174, 1, 1) 0%,
      rgba(254, 13, 160, 1) 100%
    );
    font-size: 16px;
    padding: 4px 15px 4px 4px;
    width: 75px;
  }
`

const AddToHomeScreenButton = styled.button`
  position: sticky;
  z-index: 1;
  padding: 20px 40px;
  width: fit-content;
  max-width: 350px;
  color: white;
  font-weight: bold;
  font-family: 'Open Sans';
  border: none;
  background: rgb(250, 174, 1);
  background: linear-gradient(
    90deg,
    rgba(250, 174, 1, 1) 0%,
    rgba(254, 13, 160, 1) 100%
  );
  border-radius: 5px;
  margin-top: 15px;
  align-self: flex-end;
  margin-right: 15px;
  top: 3vh;
  right: 15px;

  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);

  ${mediaQ(
    'mobileAll',
    'position: relative; position: fixed; bottom: 80px; top: unset; font-size:12px; padding:10px 15px; width: 50%;left:25%;'
  )}
`

const Tooltip = styled(ReactTooltip)`
  font-family: 'Open Sans';
  font-weight: 600;
  line-height: 15px;
  max-width: 500px;

  ${mediaQ('mobileAll', 'display: none;')}
`

const A2HSContainer = styled.div`
  position: absolute;
  right: 0;
  top: 18vh;
`

const RemoveA2HSButton = styled.button`
  position: absolute;
  z-index: 120;
  width: 30px;
  height: 30px;
  top: 2px;
  right: 2px;
  border-radius: 50%;
  border: none;
  background: url(${deleteIcon});
  background-size: contain;
  background-repeat: no-repeat;
`

const FolderSubName = styled.span`
  color: white;
  font-family: 'Asap Condensed';
  margin-top: 5px;
  ${fontSizeResponsive(22)};
`

const NewVideoBadge = styled.div`
  z-index: 1;
  width: 30px;
  height: 30px;
  border: none;
  background: url(${newVideoIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 80%;
`
const NewVideoBadgeContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  align-self: flex-end;
  position: absolute;
  top: 5px;
`
const NewVideoBadgeText = styled.span`
  width: 42px;
  height: 16px;
  font-family: 'Asap Condensed';
  font-size: 16px;
  font-weight: bold;
  /* letter-spacing: 1px; */
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  margin-right: 5px;
`

const ChatButton = styled.button`
  width: 5vw;
  height: 5vw;
  border: none;
  background: url(${chatButtonIcon});
  background-size: contain;
  background-repeat: no-repeat;
  position: fixed;
  right: 50px;
  bottom: ${(props) =>
    props.isDemoAccount && !isMobile
      ? '150px'
      : props.isDemoAccount && isMobile
      ? '22vh'
      : !props.isDemoAccount && isMobile
      ? '10vh'
      : '100px'};
  transition: all 0.4s cubic-bezier(0.53, 0.13, 0, 1.51);

  &:hover {
    transform: scale(1.12);
  }

  ${mediaQ('mobileAll', 'width: 75px; height: 75px; right: 1.5vw; z-index:2')}

  ${mediaQ('ipad9', ' width:10vw;height:10vw;z-index:2;  ')}
  ${mediaQ('ipad10', ' width:10vw;height:10vw;z-index:2;  ')}
`

const BuyFolderAccess = styled.button`
  position: absolute;
  z-index: 1;
  top: 15px;
  right: 15px;
  align-self: center;
  padding: 10px 30px;
  border: none;
  outline: none;
  background-color: rgba(158, 13, 254, 1);
  border-radius: 4px;
  font-family: 'Asap Condensed';
  text-align: center;
  font-weight: 600;
  color: white;
  -webkit-transition: ease-in-out 0.35s all;
  -webkit-transition: ease-in-out 0.35s all;
  transition: ease-in-out 0.35s all;
  box-shadow: 0 2.8px 2.2px rgb(0 0 0 / 2%), 0 6.7px 5.3px rgb(0 0 0 / 3%),
    0 12.5px 10px rgb(0 0 0 / 4%), 0 22.3px 17.9px rgb(0 0 0 / 4%),
    0 41.8px 33.4px rgb(0 0 0 / 5%), 0 100px 80px rgb(0 0 0 / 7%);
`

const FolderContainer = styled.div`
  position: relative;
`
const SubInfo = styled.div`
  color: white;
  font-family: 'Asap Condensed';
  margin-right: 15px;
  ${fontSizeResponsive(20)};

  b {
    font-weight: bold;
    margin-left: 5px;
  }
`

const MainScreen = ({
  user,
  openMenu,
  onOpenMenuClick,
  closeMenu,
  changeLocation,
  actualPage,
  onSubpageChange,
  pickFolder,
  pickedFolder,
  isPlayerActive,
  openVideo,
  activeVideoURL,
  setVideoState,
  isLoading,
  folders,
  news,
  selectedFoldersVideos,
  checkFoldersDisabled,
  logout,
  isUserDeclinedAppInstall,
  closePwaButton,
  splitFolderName,
  showNewVideoBadge,
  userMail,

  activeSubscriptionEndTime,
  updateUserSubLocalChange,
  isUserNewsletterSub,
  addMessage,
  chatMessages,
  setMessage,
  chatMessageToSend,
  reportMessage,
  editUserChatName,
  userChatName,
  isChatNameSet,
  handleChatJoinButton,
  addmessageOnEnter,
  isReportSuccess,
  handleCloseReportScreen,
  closeReportConfirmationModal,
  isReportConfirmationModalOpen,
  handleMobileReportMessage,
  isDemoAccount,
  isThisPwa,
  appReadyToInstall,
  chatModalIsOpen,
  closeChatModal,
  openChatModal,
  paidFolder,
  subStatus,
  userHasPaidContent,
  sendingMessage,
  loadingMessages,
}) => {
  const { t } = useTranslation('mainScreen')
  const { promiseInProgress } = usePromiseTracker()
  let history = useHistory()

  const [prompt, promptToInstall] = useAddToHomescreenPrompt()
  const [isVisible, setVisibleState] = React.useState(false)
  const hide = () => setVisibleState(false)

  React.useEffect(() => {
    if (prompt) {
      setVisibleState(true)
    }
  }, [prompt])

  const redirectToBuySub = () => {
    cookie.remove('userDemoMode')
    history.push('/wybierz-plan/sub')
  }

  const redirectToBuyStandalonePackage = (name) => {
    history.push(`/wybierz-plan/${name}`)
  }

  const checkIfDisplayFolder = (folder) => {
    const keywords = folder.seo_keywords
    let shouldShowcase
    let showcaseItem

    showcaseItem = keywords.filter((item) => item.text == 'DASHBOARD_SHOWCASE')
    return (shouldShowcase = showcaseItem.length == 1 ? true : false)
  }

  const checkIfPaidContent = (folder) => {
    const keywords = folder.seo_keywords
    let shouldShowcase = false
    let showcaseItem

    showcaseItem = keywords.filter((item) => item.text == 'ONLY_WEB')
    return (shouldShowcase = showcaseItem.length == 1 ? true : false)
  }

  return (
    <GenericContainer fDir="column">
      <TopColorBar
        subinfo
        className={openMenu ? 'mainScreen' : ''}
        relative
        zIndex="2"
      >
        <SubInfo>
          {subStatus && subStatus.expiration_date
            ? 'Twoja subskrypcja jest ważna do: '
            : subStatus && subStatus.expiration_date === null
            ? 'Nie posiadasz aktywnej subskcrypcji'
            : ''}
          {
            <b>
              {subStatus &&
                moment(subStatus.expiration_date).format('DD-MM-YYYY')}
            </b>
          }
        </SubInfo>
      </TopColorBar>
      <NavigationBar />
      {!isUserDeclinedAppInstall &&
      !isMobile &&
      (platform.name.includes('Chrome') || platform.name.includes('Edge')) &&
      (platform.os.family == 'Windows' ||
        (platform.name.includes('Chrome') && platform.os.family == 'OS X')) &&
      !isThisPwa ? (
        !appReadyToInstall && !isUserDeclinedAppInstall ? (
          <A2HSContainer>
            <AddToHomeScreenButton
              data-tip={
                'Aplikacja jest już zainstalwoana i możesz ją znaleźć na pulpicie komputera lub ekranie smartphona.'
              }
              className="add-button"
              data-multiline="true"
            >
              {isMobile
                ? 'Zainstalowano Miazgę, sprawdź szufladę aplikacji.'
                : 'Aplikacja MIAZGA jest zainstalowana, wejdź teraz przez ikonę na pulpicie.'}
            </AddToHomeScreenButton>
            <RemoveA2HSButton onClick={(e) => closePwaButton(e)} />
          </A2HSContainer>
        ) : appReadyToInstall && !isUserDeclinedAppInstall ? (
          <A2HSContainer>
            <AddToHomeScreenButton
              data-tip={
                !isMobile
                  ? 'Instalując stronę jako aplikację dodajesz skrót/ikonę aplikacji Miazga by Fit Matka na swój pulpit lub ekran telefonu. Dzięki temu możesz mieć zawsze aplikację pod ręką nawet bez włączania przeglądarki.'
                  : ''
              }
              className="add-button"
              data-multiline="true"
            >
              {'Kliknij by zainstalować stronę jako aplikację!'}
            </AddToHomeScreenButton>
            <RemoveA2HSButton onClick={(e) => closePwaButton(e)} />
          </A2HSContainer>
        ) : null
      ) : null}

      <WelcomeHeader>Cześć {user ? user.name : null}</WelcomeHeader>

      {!isPlayerActive && <WelcomeSubHeader>Super, że jesteś</WelcomeSubHeader>}
      {!isPlayerActive && (
        <MainScreenMainHeader>
          {t(`mainHeader.${actualPage}`)}
        </MainScreenMainHeader>
      )}
      <MainContent>
        <ChatButton isDemoAccount={isDemoAccount} onClick={openChatModal} />
        <ChatModal
          chatModalIsOpen={chatModalIsOpen}
          closeChatModal={closeChatModal}
          messages={chatMessages}
          setMessage={setMessage}
          chatMessageToSend={chatMessageToSend}
          addMessage={addMessage}
          reportMessage={reportMessage}
          editUserChatName={editUserChatName}
          userChatName={userChatName}
          isChatNameSet={isChatNameSet}
          handleChatJoinButton={handleChatJoinButton}
          addmessageOnEnter={addmessageOnEnter}
          isReportSuccess={isReportSuccess}
          handleCloseReportScreen={handleCloseReportScreen}
          closeReportConfirmationModal={closeReportConfirmationModal}
          isReportConfirmationModalOpen={isReportConfirmationModalOpen}
          handleMobileReportMessage={handleMobileReportMessage}
          user={user}
          isDemoAccount={isDemoAccount}
          sendingMessage={sendingMessage}
          loadingMessages={loadingMessages}
        />
        {!isPlayerActive && (
          <NewsSection>
            <NewsSectionHeader>
              {actualPage == 'trenning' || actualPage == 'news'
                ? t(`subHeader.${pickedFolder}`)
                : null}
            </NewsSectionHeader>
            {actualPage == 'news' && pickedFolder === 'news' && (
              <NewsContainer>
                {news
                  ? news.map((newsSingleItem, i) => (
                      <NewsItem
                        key={newsSingleItem.created_time}
                        image={newsSingleItem.pictures.sizes[3].link}
                        header={`${Math.round(
                          newsSingleItem.duration / 60
                        )} min`}
                        description={newsSingleItem.name}
                        currentNews={newsSingleItem}
                        openVideo={openVideo}
                        i={i}
                      />
                    ))
                  : null}
              </NewsContainer>
            )}
          </NewsSection>
        )}

        <FoldersSection>
          {folders &&
            folders.map(
              (folder, i) =>
                (checkIfDisplayFolder(folder) ||
                  checkIfPaidContent(folder)) && (
                  <FolderContainer>
                    {paidFolder &&
                      paidFolder.Folderorder == i &&
                      !userHasPaidContent() && (
                        <BuyFolderAccess
                          onClick={
                            paidFolder.Folderorder == i
                              ? () =>
                                  redirectToBuyStandalonePackage(folder.name)
                              : redirectToBuySub
                          }
                        >
                          {paidFolder.Folderorder == i
                            ? 'Wykup dostęp'
                            : 'Odblokuj'}
                        </BuyFolderAccess>
                      )}
                    <Folder
                      isEnabled={checkFoldersDisabled(folder, i)}
                      name={folder.name}
                      picture={folder.pictures.sizes[3].link}
                      key={folder.created_time}
                      onClick={() =>
                        pickFolder(
                          `${folder.name}`,
                          checkFoldersDisabled(folder, i),
                          folder.Folderorder,
                          folder.seo_keywords,
                          i
                        )
                      }
                    >
                      {showNewVideoBadge(
                        folder.newVideoDate,
                        folder.lastEnter,
                        i
                      ) && (
                        <NewVideoBadgeContainer>
                          <NewVideoBadge></NewVideoBadge>
                          <NewVideoBadgeText>NOWY!</NewVideoBadgeText>
                        </NewVideoBadgeContainer>
                      )}
                      <FolderName>
                        {splitFolderName(folder.name) !== undefined
                          ? splitFolderName(folder.name)[0]
                          : folder.name}{' '}
                      </FolderName>
                      {splitFolderName(folder.name) !== undefined && (
                        <FolderSubName>
                          {splitFolderName(folder.name)[1]}
                        </FolderSubName>
                      )}
                    </Folder>
                  </FolderContainer>
                )
            )}
        </FoldersSection>
      </MainContent>
      {isDemoAccount && <DemoModeAnnouncement />}

      {promiseInProgress && <Loader />}
      <Tooltip className="tooltip" type="info" />
    </GenericContainer>
  )
}

export default MainScreen
